import { Api } from '../base/Api';
import { Injectable } from '@angular/core';
import { RequestItem } from 'src/app/models/RequestItem';

@Injectable({
    providedIn: 'root'
})
export class RequestItemApi extends Api<RequestItem> {
}
